import React, {useState} from 'react'
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import CallIcon from '@material-ui/icons/Call';
import MailIcon from '@material-ui/icons/MailOutline';
import YoutubeIcon from '@material-ui/icons/YouTube';
import Modal from './Modal_Bootstrap'
import Modal_Bootstrap from './Modal_Bootstrap';

const NavBottom_Call_Mail_Youtube = (setShowNavBottom) => {
    const {value, setValue} = useState('');
    const [modalState, setModalState] = useState(false)
    const [modalTitle, setModalTitle] = useState('')
    const [modalContents, setModalContents] = useState('')
    const [showNavBottomState, setShowNavBottomState] = useState()

    

      let content1 = ["Call us at (516)-396-2256"]
      let content2 = ["Click ",<a href="mailto:LPASintakes@nasboces.org">here</a>, " or email us at LPASintakes@nasboces.org"]
      let content3 = [<iframe width="100%" height="100%" src="https://www.youtube.com/embed/geDhhWvl1II" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>]

      const setOpenModalStateFromChild = () =>{
        setModalState(false)
        setShowNavBottomStateFromParent()
      }
      function setShowNavBottomStateFromParent (setShowNavBottom){
        console.log("SHOW NAV: " + setShowNavBottom)
        setShowNavBottomState(setShowNavBottom)
      }
      return (
        <div className="App">
          {showNavBottomState ? (
            <>
            <BottomNavigation
              className="bottom-nav"
              value={value}
              onChange={(event, newValue) => {              
                if (newValue == "0"){
                    // Modal
                    setModalState(true) 
                    setModalTitle('Call Us')
                    setModalContents(content1)
                }else if(newValue == 1){
                    setModalState(true) 
                    setModalTitle('Email Us')
                    setModalContents(content2)
                }else{
                    setModalState(true) 
                    setModalTitle('Video Tutorial')
                    setModalContents(content3)
                }
              }}
              showLabels
            >
                
              <BottomNavigationAction label="Call Us" icon={<CallIcon  style={{fill: "#78C257"}} />} />
              <BottomNavigationAction label="Email Us" icon={<MailIcon  style={{fill: "#4285F4"}} />} />
              <BottomNavigationAction label="Video Tutorial" icon={<YoutubeIcon  style={{fill: "#FF0000"}} />} />
              
            </BottomNavigation>
            <Modal_Bootstrap openModal={modalState} setOpenModalStateInParent={setOpenModalStateFromChild} modalTitle={modalTitle} modalContents={modalContents}/>
            <p className='bottom-footer'>For further information, please visit <a href='https://www.nassauboces.org/lpas' target='_blank'>nassauboces.org/lpas</a></p>
            </>
          ) : (
            <></>
          )}   
          
        </div>
      )
}

export default NavBottom_Call_Mail_Youtube
